// Shared active-shop selection for owner-mode pages. Persisted in localStorage
// so the choice the owner makes on /dashboard/owner/network (or anywhere else
// that exposes the shop switcher) survives navigation to /messages, /transactions,
// etc. — and the "Inquiring as <shop>" banner on the message thread reflects it.

const KEY = "active-shop-id"
const EVENT = "active-shop-changed"

export function readActiveShopId(): string | null {
  if (typeof window === "undefined") return null
  try { return window.localStorage.getItem(KEY) } catch { return null }
}

export function writeActiveShopId(id: string | null) {
  if (typeof window === "undefined") return
  try {
    if (id) window.localStorage.setItem(KEY, id)
    else window.localStorage.removeItem(KEY)
    window.dispatchEvent(new CustomEvent(EVENT, { detail: { id } }))
  } catch { /* localStorage disabled — fail silently */ }
}

// Subscribe to changes from this tab (CustomEvent) and other tabs (storage event).
export function onActiveShopChange(handler: (id: string | null) => void): () => void {
  if (typeof window === "undefined") return () => {}
  const onCustom = (e: Event) => handler((e as CustomEvent<{ id: string | null }>).detail.id)
  const onStorage = (e: StorageEvent) => { if (e.key === KEY) handler(e.newValue) }
  window.addEventListener(EVENT, onCustom)
  window.addEventListener("storage", onStorage)
  return () => {
    window.removeEventListener(EVENT, onCustom)
    window.removeEventListener("storage", onStorage)
  }
}
